import { useState } from "react";
import { Button, Card, Collapse, Dropdown, Form } from "react-bootstrap";
import { BsDownload, BsFunnel, BsChevronLeft } from "react-icons/bs";
import { CiImport, CiSearch } from "react-icons/ci";
import { FiCheckCircle } from "react-icons/fi";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { IoIosArrowDropdown } from "react-icons/io";

const SubscriptionClientsList = () => {
    let [editPlan, setEditPlan] = useState(true);
    const modulesData = [
        {
            id: "core-hr",
            title: "Core HR/Employee Management",
            subModules: [
                { id: "sm-1-switch-1", title: "Employee Database Management", defaultChecked: true },
                { id: "sm-1-switch-2", title: "HR Administration", defaultChecked: false },
                { id: "sm-1-switch-3", title: "HR Help Desk", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "workforce-mgmt",
            title: "Workforce Management",
            subModules: [
                { id: "sm-2-switch-1", title: "Time and Attendance", defaultChecked: false },
                { id: "sm-2-switch-2", title: "Leave Management", defaultChecked: true },
                { id: "sm-2-switch-3", title: "Shift Scheduling", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "talent-acquisition",
            title: "Talent Acquisition/Recruitment",
            subModules: [
                { id: "sm-3-switch-1", title: "Applicant Tracking System (ATS)", defaultChecked: true },
                { id: "sm-3-switch-2", title: "Onboarding", defaultChecked: true },
                { id: "sm-3-switch-3", title: "Talent Pools", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "payroll",
            title: "Payroll and Compensation",
            subModules: [
                { id: "sm-4-switch-1", title: "Payroll Processing", defaultChecked: true },
                { id: "sm-4-switch-2", title: "Benefits Administration", defaultChecked: true },
                { id: "sm-4-switch-3", title: "Compensation Management", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "performance-dev",
            title: "Performance and Development",
            subModules: [
                { id: "sm-5-switch-1", title: "Performance Management", defaultChecked: true },
                { id: "sm-5-switch-2", title: "Learning and Development (L&D)", defaultChecked: true },
                { id: "sm-5-switch-3", title: "Succession Planning", defaultChecked: true },
            ],
            defaultChecked: true,
        },
        {
            id: "analytics-report",
            title: "Analytics and Reporting",
            subModules: [
                { id: "sm-6-switch-1", title: "HR Analytics", defaultChecked: true },
                { id: "sm-6-switch-2", title: "Custom Reports", defaultChecked: true },
            ],
            defaultChecked: true,
        },
    ];
    let [expandedModules, setExpandedModules] = useState({});

    let handleToggleCollapse = (moduleId) => {
        setExpandedModules((prevState) => ({
            ...prevState,
            [moduleId]: !prevState[moduleId],
        }));
    };
    return ( <>
    <div className="container-fluid py-3">
        {editPlan && (
            <Card body>
                <div className="hstack gap-2">
                    <span className="fs-6 fw-semibold">Client</span>
                    <div className="hstack gap-2 ms-auto">
                        <div className="col-12 col-md-4 col-xl-auto">
                            <div className="search-box border rounded-2">
                                <label htmlFor="clientSearch" className="searchbutton fs-16" type="button">
                                    <CiSearch />
                                </label>
                                <input type="search" id="clientSearch" placeholder="Search Client"
                                className="searchfield bg-body-tertiary rounded-2" />
                            </div>
                        </div>
                        <select name="plan-select" className="form-select me-2">
                            <option>Plan</option>
                            <option value="Basic">Basic</option>
                            <option value="Essential HR">Essential HR</option>
                            <option value="PREMIUM">PREMIUM</option>
                            <option value="Enterprise">Enterprise</option>
                        </select>
                        <Button variant="light"><BsFunnel size={16} className="me-2" /><span>Filters</span></Button>
                        <Button variant="dark"><BsDownload size={16} className="me-2" /><span>Export</span></Button>
                    </div>
                </div>
                <div className="tbl-container rounded-table rounded-2 mt-2">
                    <div className="table-responsive overflow-y-auto" style={{maxHeight: 'calc(100vh - 160px)'}}>
                        <table className="table mb-0 position-static">
                            <thead className="table-header table-light">
                                <tr>
                                    <th style={{ width: '30px' }}>
                                        <input name="client-headerCheck" className="form-check-input cursor-pointer" type="checkbox" />
                                    </th>
                                    <th>COMPANY</th>
                                    <th>PLAN</th>
                                    <th>USERS</th>
                                    <th>STATUS</th>
                                    <th>BILLING</th>
                                    <th>NEXT PAYMENT</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: 8 }).map((_, idx) => {
                                    return (
                                <tr key={idx}>
                                    <td style={{ width: '30px' }}>
                                        <input name={`client-check-${idx}`} className="form-check-input cursor-pointer" type="checkbox" />
                                    </td>
                                    <td>ACMEC INC</td>
                                    <td>PRO</td>
                                    <td>42</td>
                                    <td>Active</td>
                                    <td>Monthly</td>
                                    <td>15-11-2023</td>
                                    <td>
                                        <div className="hstack gap-2 justify-content-center">
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light"
                                                className="p-1 rounded-circle without-arrow">
                                                    <HiOutlineDotsCircleHorizontal size={20} />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item as="button" onClick={() => setEditPlan(false)}>Edit Plan</Dropdown.Item>
                                                    <Dropdown.Item as="button">Option 1</Dropdown.Item>
                                                    <Dropdown.Item as="button">Option 2</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </td>
                                </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Card>
        )}
        {!editPlan && (
            <Card body>
                <div className="hstack gap-2">
                    <Button variant="light" className='border rounded-circle p-1'
                    onClick={() => setEditPlan(true)}>
                        <BsChevronLeft size={18} />
                    </Button>
                    <div className="hstack flex-fill">
                        <span className="fs-6 fw-semibold">UNITY GAMES</span><span className="badge text-bg-success ms-2">Premium</span>
                    </div>
                    <div className="hstack gap-2 ms-auto">
                        <div className="col-12 col-md-4 col-xl-auto">
                            <div className="search-box border rounded-2">
                                <label htmlFor="modulesSearch" className="searchbutton fs-16" type="button">
                                    <CiSearch />
                                </label>
                                <input type="search" id="modulesSearch" placeholder="Modules" 
                                className="searchfield bg-body-tertiary rounded-2" />
                            </div>
                        </div>
                        <Button variant="dark">Save</Button>
                    </div>
                </div>
                <div className="vstack">
                    <div className="fs-6 fw-medim mt-3">Subscription Package</div>
                    {['radio'].map((type) => (
                        <div key={`inline-${type}`} className="mt-1">
                            <Form.Check inline label="Essential HR+" name="plans-radio" className="fs-6" 
                            type={type} id={`plan-${type}-1`} />
                            <Form.Check inline label="Professional" name="plans-radio" className="fs-6" 
                            type={type} id={`plan-${type}-2`} />
                            <Form.Check inline label="Premium" name="plans-radio" className="fs-6" 
                            type={type} id={`plan-${type}-3`} />
                            <Form.Check inline label="Enterprise" name="plans-radio" className="fs-6" 
                            type={type} id={`plan-${type}-4`} />
                            <Form.Check inline label="Custom" name="plans-radio" className="fs-6" 
                            type={type} id={`plan-${type}-5`} defaultChecked />
                        </div>
                    ))}
                </div>
                <div className="fs-6 fw-medium mt-3">Below Modules are Based on your packages :</div>
                <div className="tbl-container rounded-table rounded-2 mt-2">
                    <div className="table-responsive overflow-y-auto" style={{maxHeight: 'calc(100vh - 270px)'}}>
                        <table className="table table-striped mb-0">
                            <thead className="table-header table-light">
                                <tr>
                                    <th style={{ width: '70%' }}>MODULES</th>
                                    <th className="text-center" style={{ width: '30%' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {modulesData.map((module) => (<>
                                    <tr key={module.id}>
                                        <td style={{ width: '70%' }}>
                                            <div className="hstack gap-2" role="button" 
                                            onClick={() => handleToggleCollapse(module.id)}>
                                                <IoIosArrowDropdown size={18} className="link-dark"
                                                    style={{
                                                        transform: expandedModules[module.id] ? "rotate(180deg)" : "rotate(0deg)",
                                                        transition: "transform 0.3s ease-in-out"
                                                    }}
                                                />
                                                <span className="fw-medium">{module.title}</span>
                                            </div>
                                        </td>
                                        <td className="text-center" style={{ width: '30%' }}>
                                            <Form.Check type="switch" className="fs-6"
                                                id={`main-module-${module.id}-switch`}
                                                defaultChecked={module.defaultChecked}
                                            />
                                        </td>
                                    </tr>
                                    <tr className="p-0">
                                        <td colSpan={2} className="p-0 border-0">
                                            <Collapse in={expandedModules[module.id]}>
                                                <div>
                                                    <table className="table table-sm mb-0">
                                                        <tbody>
                                                            {module.subModules.map((subModule) => (
                                                                <tr key={subModule.id}>
                                                                    <td className="ps-4" style={{ width: '70%' }}>
                                                                        <span className="ps-2">{subModule.title}</span>
                                                                    </td>
                                                                    <td className="text-center" style={{ width: '30%' }}>
                                                                        <Form.Check type="switch" className="fs-6"
                                                                            id={`sub-module-${subModule.id}-switch`}
                                                                            defaultChecked={subModule.defaultChecked}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Collapse>
                                        </td>
                                    </tr>
                                </>))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Card>
        )}
    </div>
    </> );
}
 
export default SubscriptionClientsList;